export default "__VITE_ASSET__DLqv6B9x__"